import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';

interface LottoSaleDialogProps {
  open: boolean;
  amount: string;
  loading: boolean;
  onAmountChange: (value: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const LottoSaleDialog: React.FC<LottoSaleDialogProps> = ({
  open,
  amount,
  loading,
  onAmountChange,
  onSubmit,
  onCancel,
}) => {
  const isValid = amount && parseFloat(amount) > 0;

  return (
    <Dialog 
      open={open} 
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ background: '#EEE8FF', color: '#222B45', fontWeight: 'bold' }}>
        🛒 Lotto Sale
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Enter Sale Amount
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Enter the amount for the lotto sale transaction.
          </Typography>

          <TextField
            autoFocus
            margin="dense"
            label="Sale Amount ($)"
            type="number"
            fullWidth
            variant="outlined"
            value={amount}
            onChange={(e) => onAmountChange(e.target.value)}
            inputProps={{ 
              min: "0", 
              step: "0.01",
              placeholder: "Enter sale amount"
            }}
            sx={{ mb: 2 }}
          />

          <Alert severity="info" sx={{ mt: 2 }}>
            This will process a lotto sale transaction for the specified amount.
          </Alert>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button 
          onClick={onSubmit} 
          variant="contained"
          disabled={!isValid || loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
          sx={{ color: '#ffffff', fontWeight: 600, fontSize: '15px', backgroundColor: '#2C6CA0' }}
        >
          {loading ? 'Processing...' : 'Process Sale'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}; 